const actionCreators = {
    //A message action creator doesn't take a payload,
    //and is simply used to notify that a process/action is taking place
    message: type => () => ({ type }),

    //logs are messages that should never be listened for, but are only
    //dispatched for logging purposes
    log: type => (...args) => ({ type: `--- ${type} ---`, payload: args })
};

export default actionCreators;
